/* Interior brand invariant: the native Shop / Shop Pay wordmark and installment
   help icon always stay Shop purple (#5a31f4), in both light and dark appearance.
   Shopify owns the copy, SVG artwork, disclosure and payment behavior. */
(() => {
  if (!document.body.classList.contains('loc-interior-page')) return;
  const brand = 'rgb(90, 49, 244)';
  const roots = new WeakSet();
  const waiting = new WeakSet();

  const setBrand = (element, property) => {
    if (element.style.getPropertyValue(property) !== brand ||
        element.style.getPropertyPriority(property) !== 'important') {
      element.style.setProperty(property, brand, 'important');
    }
  };

  const isShopWordmark = (svg) => {
    const name = svg.getAttribute('aria-label') || svg.querySelector('title')?.textContent || '';
    return /^shop(?:\s+pay)?$/i.test(name.trim());
  };

  const styleComponent = (component) => {
    const root = component.shadowRoot;
    if (!root) {
      /* Custom elements may attach their shadow root after the host was inserted.
         This bounded retry complements whenDefined without patching native APIs. */
      if (!waiting.has(component)) {
        waiting.add(component);
        let attempts = 0;
        const waitForRoot = () => {
          if (!component.isConnected || ++attempts > 40) {
            waiting.delete(component);
            return;
          }
          if (component.shadowRoot) {
            waiting.delete(component);
            styleComponent(component);
            return;
          }
          window.setTimeout(waitForRoot, 250);
        };
        window.setTimeout(waitForRoot, 250);
      }
      return;
    }
    const paint = () => {
      const disclosure = root.querySelector('#shopify-installments-cta');
      if (disclosure) setBrand(disclosure, 'color');
      root.querySelectorAll('svg').forEach((svg) => {
        if (!isShopWordmark(svg)) return;
        setBrand(svg, 'color');
        /* Only filled shapes of the identified original wordmark. Never apply
           filters or recolour arbitrary SVGs, payment copy or other brand assets. */
        svg.querySelectorAll('path, use, polygon, rect, circle, ellipse').forEach((shape) => {
          if (shape.getAttribute('fill') !== 'none') setBrand(shape, 'fill');
        });
      });
    };
    paint();
    if (roots.has(root)) return;
    roots.add(root);
    new MutationObserver(paint).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'fill', 'aria-label'],
    });
  };

  const scan = () => document.querySelectorAll('shopify-payment-terms').forEach(styleComponent);
  let queued = false;
  const scheduleScan = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      scan();
    });
  };
  scan();
  customElements.whenDefined('shopify-payment-terms').then(scheduleScan);
  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
})();
